module.exports = __webpack_public_path__ + "img/1.962729db.png";